export const SELECT_ACCOUNT = 'Select Account';
export const DESELECT_ACCOUNT = 'Deselect Account';
export const EDIT_ACCOUNT = 'Edit Account';
export const DELETE_ACCOUNT = 'Delete Account';
